var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 3.83333H13.168V2.16667C13.168 1.72464 12.9924 1.30072 12.6798 0.988155C12.3673 0.675595 11.9433 0.5 11.5013 0.5H6.5013C6.05927 0.5 5.63535 0.675595 5.32279 0.988155C5.01023 1.30072 4.83464 1.72464 4.83464 2.16667V3.83333H0.667969V5.5H2.33464V18C2.33464 18.663 2.59803 19.2989 3.06687 19.7678C3.53571 20.2366 4.17159 20.5 4.83464 20.5H13.168C13.831 20.5 14.4669 20.2366 14.9357 19.7678C15.4046 19.2989 15.668 18.663 15.668 18V5.5H17.3346V3.83333ZM6.5013 2.16667H11.5013V3.83333H6.5013V2.16667ZM14.0013 18C14.0013 18.221 13.9135 18.433 13.7572 18.5893C13.6009 18.7455 13.389 18.8333 13.168 18.8333H4.83464C4.61362 18.8333 4.40166 18.7455 4.24538 18.5893C4.0891 18.433 4.0013 18.221 4.0013 18V5.5H14.0013V18Z",
    fill: "#005C8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16862 8.83301H6.50195V15.4997H8.16862V8.83301Z",
    fill: "#005C8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5007 8.83301H9.83398V15.4997H11.5007V8.83301Z",
    fill: "#005C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.40b7ea8bb19f74f4f4ef7b62c57eec9b.svg";
export { ForwardRef as ReactComponent };